import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import {
  COMPANIES_URL,
  SOLUTIONS_URL,
  INVESTORS_URL,
  SERVICE_PROVIDERS_URL
} from 'global-constants';

import styles from './styles.module.scss';

class DirectoryDropdown extends Component {
  render() {
    return (
      <div className={styles.directoryDropdownWrapper}>
        <NavLink
          id="navigation-companies"
          className={styles.item}
          to={COMPANIES_URL}
          activeClassName={styles.selectedItem}>
          PropTech Companies
        </NavLink>
        <NavLink
          id="navigation-investors"
          className={styles.item}
          to={INVESTORS_URL}
          activeClassName={styles.selectedItem}>
          PropTech Investors
        </NavLink>
        <NavLink
          id="navigation-service-providers"
          className={styles.item}
          to={SERVICE_PROVIDERS_URL}
          activeClassName={styles.selectedItem}>
          Service Providers
        </NavLink>
        <NavLink
          id="navigation-solutions"
          className={styles.item}
          to={SOLUTIONS_URL}
          activeClassName={styles.selectedItem}>
          Browse Solutions
        </NavLink>
      </div>
    );
  }
}

export default DirectoryDropdown;
